// extracted by mini-css-extract-plugin
export var copyModule = "copy-module-module--copy-module--3c587";
export var copyModuleDark = "copy-module-module--copy-module--dark--76d0d";
export var copyModuleFull = "copy-module-module--copy-module--full--d4627";
export var copyModule__badges = "copy-module-module--copy-module__badges--4ef91";
export var copyModule__badges__callout = "copy-module-module--copy-module__badges__callout--fe67d";
export var copyModule__badges__img = "copy-module-module--copy-module__badges__img--32a99";
export var copyModule__badges__item = "copy-module-module--copy-module__badges__item--7e10d";
export var copyModule__body = "copy-module-module--copy-module__body--83fcb";
export var copyModule__cta = "copy-module-module--copy-module__cta--59915";
export var copyModule__eyebrow = "copy-module-module--copy-module__eyebrow--5ac13";
export var copyModule__eyebrowImg = "copy-module-module--copy-module__eyebrow-img--41de1";
export var copyModule__title = "copy-module-module--copy-module__title--c3152";
export var mt0 = "copy-module-module--mt-0--3284a";
export var mt1 = "copy-module-module--mt-1--b12af";
export var mt2 = "copy-module-module--mt-2--c29a4";
export var mt3 = "copy-module-module--mt-3--7bd46";
export var mt4 = "copy-module-module--mt-4--d33dd";
export var mt5 = "copy-module-module--mt-5--37b9e";
export var mt6 = "copy-module-module--mt-6--0bb3c";